<template>
    <div>
        <div class="bg-slate-100 min-h-screen flex items-center py-16">
            <div class="max-w-3xl mx-auto px-6 w-full">

                <div class="bg-white rounded-2xl shadow-lg border p-10 text-center">

                    <!-- ICON -->
                    <div class="w-20 h-20 mx-auto rounded-full bg-red-50 flex items-center justify-center mb-6">
                        <i class="fas fa-exclamation-triangle text-3xl text-red-500"></i>
                    </div>

                    <!-- TITLE -->
                    <h1 class="text-3xl font-bold text-gray-900 mb-4">
                        Votre licence est expirée
                    </h1>

                    <!-- DESCRIPTION -->
                    <p class="text-gray-600 text-lg leading-relaxed mb-8">
                        L’accès à votre espace professionnel est temporairement suspendu.
                        Vos données sont conservées en toute sécurité.
                    </p>

                    <!-- INFO BOX -->
                    <div class="bg-blue-50 border-l-4 border-blue-500 p-5 rounded text-left mb-8">
                        <p class="text-blue-900 text-sm">
                            Aucun contenu n’a été supprimé.  
                            Une simple régularisation permet une réactivation immédiate de votre accès.
                        </p>
                    </div>

                    <!-- ACTIONS -->
                    <div class="bg-gray-100 rounded-lg p-6 text-left">
                        Pour régulariser votre situation, veuillez contacter notre support à l’adresse <a href="mailto:contact@termoflow.fr">contact@termoflow.fr</a>.
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            licenceExpired() {
                if (this.$account.account.societe.date_licence) {
                    let expiryDate = moment(this.$account.account.societe.date_licence);
                    let now = moment();
                    return now.isAfter(expiryDate);
                }
                return false;
            }
        },
        mounted() {
            if (!this.licenceExpired) {
                this.$router.push({name: 'Home'})
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>